import React, { createContext, useContext, useState, useCallback } from 'react';

export interface BatchProgressState {
  active: boolean;
  total: number;
  label?: string;
}

interface BatchProgressContextType {
  batchState: BatchProgressState | null;
  startBatch: (total: number, label?: string) => void;
  endBatch: () => void;
}

const BatchProgressContext = createContext<BatchProgressContextType | undefined>(undefined);

export const BatchProgressProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [batchState, setBatchState] = useState<BatchProgressState | null>(null);

  const startBatch = useCallback((total: number, label?: string) => {
    setBatchState({
      active: true,
      total,
      label: label || 'documents',
    });
  }, []);

  const endBatch = useCallback(() => {
    setBatchState(null);
  }, []);

  return (
    <BatchProgressContext.Provider value={{ batchState, startBatch, endBatch }}>
      {children}
    </BatchProgressContext.Provider>
  );
};

export function useBatchProgress() {
  const context = useContext(BatchProgressContext);
  if (!context) throw new Error('useBatchProgress must be used inside BatchProgressProvider');
  return context;
}
